import React from 'react';
import { Col, Form, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import {
  StoryOrientation,
  StoryOrientationLabels,
} from '../../dorian-shared/types/story/Story';

const orientationOptions = [
  { value: StoryOrientation.VERTICAL, label: StoryOrientationLabels[StoryOrientation.VERTICAL] },
  { value: StoryOrientation.HORIZONTAL, label: StoryOrientationLabels[StoryOrientation.HORIZONTAL] },
];

/**
 * Переиспользуемый компонент для выбора ориентации RenPy
 * @param {Object} props
 * @param {string} props.value - Текущее значение ориентации
 * @param {Function} props.onChange - Функция обработки изменения значения
 * @param {boolean} props.isDisabled - Флаг отключения компонента
 * @param {boolean} props.validated - Флаг валидации формы
 * @param {boolean} props.required - Флаг обязательности поля
 * @param {string} props.controlId - ID для контрола (по умолчанию 'orientationSelect')
 */
export function RenPyOrientationSelector({
  value,
  onChange,
  isDisabled = false,
  validated = false,
  required = true,
  controlId = 'orientationSelect',
}) {
  const currentOption = orientationOptions.find((option) => option.value === value) || null;

  const handleChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : null;
    onChange(newValue);
  };

  return (
    <>
      <Form.Label as={Col} sm="auto">Orientation</Form.Label>
      <Form.Group
        as={Col}
        sm={2}
        className="m-0 py-0"
        style={{ minWidth: '200px' }}
        controlId={controlId}
      >
        <Select
          id={controlId}
          value={currentOption}
          onChange={handleChange}
          options={orientationOptions}
          placeholder="Select orientation..."
          className="react-select-container"
          classNamePrefix="react-select"
          isDisabled={isDisabled}
          required={required}
        />
        {/* Need for validation */}
        <FormControl
          type="hidden"
          name="orientation"
          value={value || ''}
          isInvalid={validated && required && !value}
        />
        <Form.Control.Feedback type="invalid">
          Please select an orientation.
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
